module.exports = __webpack_public_path__ + "img/welcomes-preview-current-empty-white.ab480abb.png";